import { ImagePickerProviderProps } from './ImagePickerContextTypes'
import { WithSteps, WithoutSteps } from 'components/Types'
import { ModalProps } from 'almanac-ui/Modal/Types'

export interface IImagePickerModalContainerProps
  extends Omit<ImagePickerProviderProps, 'children'>,
    IImagePickerModalProps {}

export type ImagePickerModalContainerProps = IImagePickerModalContainerProps & { steps?: string[]; step?: number }

interface IImagePickerModalProps extends Pick<ModalProps, 'onPressOutside'> {
  title?: string
  accept?: string
  brandKitId?: number
}

export type ImagePickerModalProps = (IImagePickerModalProps & WithSteps) | (IImagePickerModalProps & WithoutSteps)

export type Provider = 'stock' | 'uploads' | 'link' | 'gifs' | 'ai' | 'brandKits'
export enum Providers {
  stock = 'stock',
  uploads = 'uploads',
  link = 'link',
  gifs = 'gifs',
  ai = 'ai',
}
